import React, { useState, useEffect } from "react";

import classNames from 'classnames';

const Loader = ({type, size, center, className, color=null, style={}})=> {

  const [spinnerStyle ,setStyle] = useState({height: "inherit", width: 50, height: 50, ...style});

  useEffect(()=> {
    if(size) setStyle({...spinnerStyle, ...{width: size, height: size}});
  }, []);

  return (
    <div className={classNames({"d-flex jc-center": center})}>
      <div className={classNames("loader-box", {[className]: className})} style={spinnerStyle}>
        <div className={`loader-${type}`} style={{borderColor: color, width: '100%', height: '100%'}}></div>
      </div>
    </div>
  );

}

export default Loader;
